// Fetch Preferences
export const FETCH_PREFERENCES_REQUEST = 'preferences/fetchRequest'
export const FETCH_PREFERENCES_SUCCESS = 'preferences/fetchSuccess'
export const FETCH_PREFERENCES_FAILURE = 'preferences/fetchFailure'

// Update Preferences
export const UPDATE_PREFERENCES_REQUEST = 'preferences/updateRequest'
export const UPDATE_PREFERENCES_SUCCESS = 'preferences/updateSuccess'
export const UPDATE_PREFERENCES_FAILURE = 'preferences/updateFailure'
